import { PageMetaDataModel } from '../services/seo';

/**
 * It takes an array of PageMetaDataModel objects and a pageEnum string and returns the
 * PageMetaDataModel object that matches the pageEnum string
 * @param {PageMetaDataModel[]} array - PageMetaDataModel[] - this is the array of objects that we are
 * searching through.
 * @param {string} pageEnum - This is the page enum that you want to find the SEO data for.
 * @returns the first item in the array that matches the pageEnum.
 */
export function findSeoInsidePage(array: PageMetaDataModel[], pageEnum: string) {
  return array?.find(item => item.page === pageEnum);
}
